import React, { useState } from 'react'

export const ProductTab = () => {

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <div className="xl:px-16 px-4">
      <div className="md:flex flex-wrap text-center mt-2 gap-10">

        <div className={toggleState === 1 ? "power-tab text-left flex items-center active-tabs cursor-pointer" : "power-tab text-left flex items-center cursor-pointer"} onClick={() => toggleTab(1)}>
          <div className="info flex p-3 power-tab_enable flex-col">
            DESCRIPTION
          </div>
        </div>

        <div className={toggleState === 2 ? "power-tab text-left flex items-center active-tabs cursor-pointer" : "power-tab text-left flex items-center cursor-pointer"} onClick={() => toggleTab(2)}>
          <div className="info display-flex p-3 bord">
            SPECIFICATION
          </div>
        </div>

        <div className={toggleState === 3 ? "power-tab text-left flex items-center active-tabs cursor-pointer" : "power-tab text-left flex items-center cursor-pointer"} onClick={() => toggleTab(3)}>
          <div className="info display-flex p-3 bord">
            CAUTION
          </div>
        </div>

        <div className={toggleState === 4 ? "power-tab text-left flex items-center active-tabs cursor-pointer" : "power-tab text-left flex items-center cursor-pointer"} onClick={() => toggleTab(4)}>
          <div className="info display-flex bord p-3">
            SHIPPING
          </div>
        </div>

      </div>

      <div className="flex-row pt-8 lg:py-8 lg:pb-10 border-t-2 mt-[-2px] border-gray-300">
        <div className={toggleState === 1 ? "first_step  block font-light" : "first_step hidden"}>
          <h2 className="text-2xl mb-3">Applicable to both light & dark eyes!</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde consectetur omnis a libero doloremque itaque nihil exercitationem dignissimos eos modi dolorum sit, ipsa et debitis voluptatibus culpa temporibus autem praesentium eum magni impedit corrupti. Voluptates temporibus minus aliquam distinctio doloribus excepturi sint, debitis non praesentium consequatur ab earum quo delectus voluptatem pariatur molestiae expedita cupiditate labore voluptatum accusamus minima. Provident vel expedita totam ipsum quibusdam, quisquam enim quam iusto nesciunt reprehenderit voluptates.</p>
        </div>
        <div className={toggleState === 2 ? "second_step block font-light" : "second_step hidden"}>
          <p>Water content: 38%</p>
          <p>Thickness: 0.08mm</p>
          <p>Texture: Polymacon</p>
          <p>Base curve: 8.5mm</p>
          <p>Diameter: 14mm</p>
          <p>Period of use: 12 months</p>
          <p>Packaging: 1 Pair (2 lenses)</p>
        </div>
        <div className={toggleState === 3 ? "third_step block font-light" : "third_step hidden"}>
          <p>1. Before the first time wearing, please soak the lenses in a multi-purpose contact lens solution for at least 6 hours.</p>
          <p>2. Please take off your lenses before sleeping.</p>
          <p>3. Please do not attend any water sports when wearing lenses.</p>
          <p>4. Always wash your hands before wearing, removing, or handling your contact lenses.</p>
          <p>5. Rinse and scrub your lens every 2-3 days to prevent protein precipitation which is not good for the eyes.</p>
          <p>6. Insert lenses before putting on make-up around the eyes, and take off lenses before removing make-up.</p>
          <p>7. Contact lenses are not one size fits all, please check with your Eye Care specialist to make sure whether the parameters are suitable for your eyes before purchasing.</p>
        </div>
        <div className={toggleState === 4 ? "fourth_step block font-light" : "fourth_step hidden"}>
          <p>🌐 FREE WORLDWIDE SHIPPING on orders over $25.</p>

          <p className="my-2">✈️ STANDARD SHIPPING (10-20 working days), FREE over $25.</p>

          <p>🚀 EXPRESS SHIPPING (5-8 working days), US only</p>
        </div>
      </div>
    </div>
  )
}